import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {InterventionApi} from "../services/InterventionService";
import {useParams} from "react-router-dom";
import {showToastModal} from "../jsx/components/shared/ToastModalSwal";

export const useDailyIntervention = ({size, filter, order, search}) => {
  const {data, isLoading, isError, error, isFetching, refetch} = useQuery({
    queryKey: [
      "interventions",
      size,
      JSON.stringify(filter),
      JSON.stringify(order),
      search,
    ],
    queryFn: () =>
      InterventionApi.getAll({
        size,
        filter,
        order,
        search,
      }),

    select: (data) => {
      // Flatten pages into a single array
      return data.rows;
    },
  });

  return {
    interventions: data,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  };
};

export const useGetIntervention = () => {
  const {id} = useParams();

  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["interventions", id],
    queryFn: () => InterventionApi.getOne({id}),
    enabled: !!id,
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const useUpdateIntervention = () => {
  const queryClient = useQueryClient();
  const {mutateAsync: update} = useMutation({
    mutationFn: InterventionApi.update,
  });
  const {mutateAsync: createNextIntervention} = useMutation({
    mutationFn: InterventionApi.CreateNextIntervention,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["interventions"]});
      showToastModal({
        title: "Intervention ajoutée",
        message: "L’intervention a été créée avec succès.",
        success: true,
      });
    },
  });

  const {mutateAsync: payIntervention} = useMutation({
    mutationFn: InterventionApi.payIntervention,
    onSuccess: () => {},
  });

  const onCreateNextIntervention = ({
    interventionId,
    nextProposal,
    ...rest
  }) => {
    return createNextIntervention({
      body: {
        interventionId,
        nextProposal,
        ...rest,
      },
    });
  };

  const onPayIntervention = async ({interventionId}) => {
    try {
      const response = await payIntervention({interventionId});

      return response;
    } catch (error) {
      // Error paying proposal
      throw error;
    }
  };

  const onUpdateIntervention = ({id, body}) => {
    return update(
      {id, body},
      {
        onSuccess: () => {
          queryClient.invalidateQueries({queryKey: ["interventions"]});
          queryClient.invalidateQueries({queryKey: ["chatRooms"]});
          queryClient.invalidateQueries({queryKey: ["chatRoom"]});
          showToastModal({
            title: "Intervention modifiée",
            message: "L'intervention a été modifiée avec succès.",
            success: true,
          });
          // showToastModal({success:true, title:"modification"})
        },
      },
    );
  };
  const onFinalizeIntervention = ({id, body}) => {
    return update(
      {id, body},
      {
        onSuccess: () => {
          queryClient.invalidateQueries({queryKey: ["interventions"]});
          queryClient.invalidateQueries({queryKey: ["chatRooms"]});
          queryClient.invalidateQueries({queryKey: ["chatRoom"]});

          // showToastModal({success:true, title:"modification"})
        },
      },
    );
  };

  return {
    onUpdateIntervention,
    onCreateNextIntervention,
    onPayIntervention,
    onFinalizeIntervention,
  };
};
